import React, { useState, useEffect } from 'react';
import { postAPI } from '../../../app/api';
import Modal from '../../../GlobalComponent/Modal';
import viewIcon from "../../../assets/img/view-icon.svg"
// HTML Assets Base URL
const HTML_ASSETS_URL = 'https://retechprime.com/be-college-ex-students-club/html/';

export default function GallerySection() {
    const [galleryImages, setGalleryImages] = useState([]);
    const [loading, setLoading] = useState(true);
    const [clickedImg, setClickedImg] = useState(null);
    const [currentIndex, setCurrentIndex] = useState(null);

    useEffect(() => {
        const fetchGallery = async () => {
            try {
                setLoading(true);
                const response = await postAPI('gallery/listFiles', {});
                if (response?.status === 1) {
                    const filtered = (response?.data || []).filter(img =>
                        img.show_in_homepage === 1 || img.show_in_homepage === "1"
                    );
                    setGalleryImages(filtered);
                }
            } catch (e) {
                console.error('Error fetching gallery:', e);
            } finally {
                setLoading(false);
            }
        };
        fetchGallery();
    }, []);

    const handleClick = (item, index) => {
        setCurrentIndex(index);
        setClickedImg(item?.file_url);
    };

    const handelRotationRight = () => {
        const totalLength = galleryImages.length;
        if (currentIndex + 1 >= totalLength) {
            setCurrentIndex(0);
            setClickedImg(galleryImages[0].file_url);
            return;
        }
        const newIndex = currentIndex + 1;
        setClickedImg(galleryImages[newIndex].file_url);
        setCurrentIndex(newIndex);
    };

    const handelRotationLeft = () => {
        const totalLength = galleryImages.length;
        if (currentIndex === 0) {
            setCurrentIndex(totalLength - 1);
            setClickedImg(galleryImages[totalLength - 1].file_url);
            return;
        }
        const newIndex = currentIndex - 1;
        setClickedImg(galleryImages[newIndex].file_url);
        setCurrentIndex(newIndex);
    };

    return (
        <>
            <section className="gallery py-5">
                <div className="container-xxl container-lg container-fluid">
                    {/* Header */}
                    <div className="row align-items-start">
                        <div className="col-xl-10 col-lg-8 col-md-9">
                            <div className="heading">
                                <h2 className="text-primary">Our Gallery</h2>
                                <p className="mt-2">Our gallery captures the memorable moments shared by members of the BE College Ex-Students' Club — from cultural evenings and seminars to annual celebrations and family gatherings. Each photograph reflects the warmth, unity, and spirit that define our alumni community.</p>
                            </div>
                        </div>

                        <div className="col-xl-2 col-lg-4 col-md-3 text-lg-end mt-3 mt-lg-0">
                            <a href="/gallery" className="btn btn-primary">
                                VIEW MORE <img src={`${HTML_ASSETS_URL}assets/images/icon/double-arrow-icon.svg`} alt="Arrow" />
                            </a>
                        </div>
                    </div>

                    {/* Gallery Grid */}
                    <div className="row g-3 gallery-grid">
                        {loading ? (
                            <div className="col-12 text-center py-5">
                                <div className="spinner-border text-primary" role="status">
                                    <span className="visually-hidden">Loading...</span>
                                </div>
                            </div>
                        ) : galleryImages && galleryImages.length > 0 ? (
                            galleryImages.slice(0, 6).map((image, index) => {
                                const imageUrl = image.file_url;
                                const isBig = index === 0 || index === 5;

                                // For big images (first and last column)
                                if (isBig) {
                                    return (
                                        <div key={index} className="col-lg-3 col-md-6">
                                            <div
                                                className="gallery-item img-big"
                                                onClick={() => handleClick(image, index)}
                                                style={{ cursor: 'pointer' }}
                                            >
                                                <img
                                                    src={imageUrl || `${HTML_ASSETS_URL}assets/images/gallery/gallery-01.png`}
                                                    className="img-fluid rounded-4 w-100"
                                                    alt={image.gallery_file_name}
                                                />
                                                <div className="overlay">
                                                    <span className="plus-icon">
                                                        <img src={viewIcon} alt="View" />
                                                    </span>
                                                    <div className="img-info">
                                                        {/* <small>{new Date(image.createdAt).toLocaleDateString('en-IN', { day: 'numeric', month: 'short', year: 'numeric' })}</small> */}
                                                        <h6 className="mb-0">{image.gallery_file_name || 'Bengal Engineering College'}</h6>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    );
                                }

                                // Small paired images column 2
                                if (index === 1) {
                                    return (
                                        <div key={index} className="col-lg-3 col-md-6">
                                            {[1, 2].map((pairIndex) => {
                                                const pairImage = galleryImages[pairIndex];
                                                if (!pairImage) return null;
                                                return (
                                                    <div
                                                        key={pairIndex}
                                                        className={`gallery-item img-small ${pairIndex === 1 ? 'mb-3' : ''} d-inline-block w-100`}
                                                        onClick={() => handleClick(pairImage, pairIndex)}
                                                        style={{ cursor: 'pointer' }}
                                                    >
                                                        <img
                                                            src={pairImage.file_url || `${HTML_ASSETS_URL}assets/images/gallery/gallery-02.png`}
                                                            className="img-fluid rounded-4 w-100"
                                                            alt={pairImage.gallery_file_name}
                                                        />
                                                        <div className="overlay">
                                                            <span className="plus-icon">
                                                                <img src={viewIcon} alt="View" />
                                                            </span>
                                                            <div className="img-info">
                                                                {/* <small>{new Date(pairImage.createdAt).toLocaleDateString('en-IN', { day: 'numeric', month: 'short', year: 'numeric' })}</small> */}
                                                                <h6 className="mb-0">{pairImage.gallery_file_name || 'Bengal Engineering College'}</h6>
                                                            </div>
                                                        </div>
                                                    </div>
                                                );
                                            })}
                                        </div>
                                    );
                                }

                                // Small paired images column 3
                                if (index === 3) {
                                    return (
                                        <div key={index} className="col-lg-3 col-md-6">
                                            {[3, 4].map((pairIndex) => {
                                                const pairImage = galleryImages[pairIndex];
                                                if (!pairImage) return null;
                                                return (
                                                    <div
                                                        key={pairIndex}
                                                        className={`gallery-item img-small ${pairIndex === 3 ? 'mb-3' : ''} d-inline-block w-100`}
                                                        onClick={() => handleClick(pairImage, pairIndex)}
                                                        style={{ cursor: 'pointer' }}
                                                    >
                                                        <img
                                                            src={pairImage.file_url || `${HTML_ASSETS_URL}assets/images/gallery/gallery-04.png`}
                                                            className="img-fluid rounded-4 w-100"
                                                            alt={pairImage.gallery_file_name}
                                                        />
                                                        <div className="overlay">
                                                            <span className="plus-icon">
                                                                <img src={viewIcon} alt="View" />
                                                            </span>
                                                            <div className="img-info">
                                                                {/* <small>{new Date(pairImage.createdAt).toLocaleDateString('en-IN', { day: 'numeric', month: 'short', year: 'numeric' })}</small> */}
                                                                <h6 className="mb-0">{pairImage.gallery_file_name || 'Bengal Engineering College'}</h6>
                                                            </div>
                                                        </div>
                                                    </div>
                                                );
                                            })}
                                        </div>
                                    );
                                }

                                return null;
                            })
                        ) : (
                            <div className="col-12 text-center py-5">
                                <p className="text-muted">No gallery images available</p>
                            </div>
                        )}
                    </div>
                </div>
            </section>
            {clickedImg && (
                <Modal
                    clickedImg={clickedImg}
                    handelRotationRight={handelRotationRight}
                    setClickedImg={setClickedImg}
                    handelRotationLeft={handelRotationLeft}
                />
            )}
        </>
    )
}
